import React from 'react';

import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from '@buyside/components/presentation/Skeleton/skeleton';

import styles from './ideaOverviewStyles.scss';

const IdeaOverviewLoading: React.FC = () => (
  <div id="idea_overview" className={styles.overviewLoading}>
    <div className={styles.showCardHeader}>
      <Skeleton
        containerHeight={50}
        containerWidth={360}
        size={SKELETON_SIZES.LARGE}
        width={SKELETON_WIDTHS.LARGE}
      />
    </div>
    <br />
    <div className={styles.ideaBasicInfo}>
      <div className={styles.ideaBasicInfoItem}>
        <Skeleton width={SKELETON_WIDTHS.SMALL} size={SKELETON_SIZES.SMALL} />
      </div>
      <div className={styles.ideaBasicInfoItem}>
        <Skeleton width={SKELETON_WIDTHS.SMALL} size={SKELETON_SIZES.SMALL} />
      </div>
      <div className={styles.ideaBasicInfoItem}>
        <Skeleton width={SKELETON_WIDTHS.SMALL} size={SKELETON_SIZES.SMALL} />
      </div>
      <div className={styles.ideaBasicInfoItem}>
        <Skeleton width={SKELETON_WIDTHS.SMALL} size={SKELETON_SIZES.SMALL} />
      </div>
    </div>
    <div className={styles.elevatorPitch}>
      <Skeleton width={SKELETON_WIDTHS.FULL} />
      <Skeleton width={SKELETON_WIDTHS.ONE_THIRD} />
    </div>
  </div>
);

export default IdeaOverviewLoading;
